import { AuthErrorFromUrl } from "@features/sign-in";

export const AuthErrorPage = () => <AuthErrorFromUrl />;
